require('./pushmenu.js');

(function(window){
  function MobileMenu(container, params) {
    try {
      if (!container) {
        throw 'Container is required!';
      }

      this.container = container;
      if (params) {
        this.setParams(params);
      }
      this.init();
    } catch (error) {
      console.error(error);
    }
  }

  MobileMenu.prototype = {
    container: undefined,
    categoriesContainer: undefined,
    listSelector: undefined,
    categories:[],
    texts: {
      backText: 'Vissza'
    },
    init: function() {
      this.setElements();
      this.createContent();
      this.container.pushMenu({
        type:"cover",
        levelSpacing:0,
        backClass:"mp-back",
        trigger: ".mobile-menu-btn",
        pusher:".mobile-menu-outer",
      });
    },
    setElements: function() {
      if (this.listSelector) {
        this.categoriesContainer = $(this.listSelector);
      }
    },
    addDOMEvents: function() {

    },
    createContent: function() {
      if (this.categoriesContainer && this.categoriesContainer.length == 1 && this.categories.length > 0) {
        for (var i = 0; i < this.categories.length; i++) {
          var category = this.categories[i];
          var listItem = $('<li>');
          var children = typeof category.children === 'object' && Array.isArray(category.children) ? category.children : [];
          listItem.append($('<a>', {
            'href': typeof category.link !== 'undefined' ? category.link : 'javascript:void(0)',
            'class': 'mobile-menu-item',
            'html': '<span class="text">'+category.name+'</span>'+(children.length > 0 ? '<span class="arrow">'+this.writeSvg('arrow-down')+'</span>' : '')
          }));
          if (children.length > 0) {
            listItem.append(this.createSubmenuContent(children, 2));
          }
          this.categoriesContainer.append(listItem);
        }
      }
    },
    createSubmenuContent: function(items, level) {
      if (items.length > 0) {
        var levelClass = '';
        switch (parseInt(level)) {
          case 2:
            levelClass = 'second-level';
            break;
          case 3:
            levelClass = "third-level";
            break;
          case 4:
            levelClass = 'fourth-level';
            break;
          case 5:
            levelClass = 'fifth-level';
            break;
        }
        var content = $('<div>', {
          'class': 'mp-level'
        });

        var inner = $('<div>', {
          'class': 'inner'
        });

        var list = $('<ul>', {
          class:'sub-menu '+levelClass
        });

        list.append('<li><a href="javascript:void(0)" class="mp-back">'+this.writeSvg('arrow-down')+'<span class="text">'+this.getText('backText')+'</span></a></li>')
        for (var i = 0; i < items.length; i++) {
          var category = items[i];
          var listItem = $('<li>');
          var children = typeof category.children === 'object' && Array.isArray(category.children) ? category.children : [];
          listItem.append($('<a>', {
            'href': typeof category.link !== 'undefined' ? category.link : 'javascript:void(0)',
            'class': 'mobile-menu-item',
            'html': '<span class="text">'+category.name+'</span>'+(children.length > 0 ? '<span class="arrow">'+this.writeSvg('arrow-down')+'</span>' : '')
          }));
          if (children.length > 0) {
            listItem.append(this.createSubmenuContent(children, level+1));
          }

          list.append(listItem);
        }
        inner.append(list);
        content.append(inner);

        return content;
      }
    },
    setParams: function(params) {
      if (params.listSelector) this.setListSelector(params.listSelector);
      if (params.categories) this.setCategories(params.categories);
    },
    setListSelector: function(selector) {
      this.listSelector = selector;
    },
    setCategories: function(categories) {
      if (Array.isArray(categories)) {
        this.categories = categories;
      }
    },
    writeSvg: function(icon) {
      return '<svg class="icon '+icon+'"><use xlink:href="#'+icon+'" /></svg>';
    },
    getText: function(key) {
      return typeof this.texts[key] !== 'undefined' ? this.texts[key] : key;
    }

  };

  window.MobileMenu = MobileMenu;
})(window);
